import { render, staticRenderFns } from "./HighIncomeInsight.vue?vue&type=template&id=ad85c538&scoped=true"
import script from "./HighIncomeInsight.vue?vue&type=script&lang=js"
export * from "./HighIncomeInsight.vue?vue&type=script&lang=js"
import style0 from "./HighIncomeInsight.vue?vue&type=style&index=0&id=ad85c538&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad85c538",
  null
  
)

export default component.exports